import { COLORS } from 'Components/utils/color/colors';

const NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-1 mt-2',
    thControl: 'mx-1',
  },
  center: {
    thInner: 'relative',
    thControls:
      'z-2 absolute flex justify-between pointer-events-none top-1/2 -translate-y-50 w-full',
    thControl: 'pointer-events-auto click-zone-lg',
    thControlLeft: '-translate-x-50',
    thControlRight: 'translate-x-50',
    thControlDisabled: 'invisible',
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-1',
    thControl: 'mx-1',
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-1 mb-2 -order-1',
    thControl: 'mx-1',
  },
};

export const themes = {
  default: ({ navPosition }) => {
    return {
      ...NAV_POSITION_CLASSES[navPosition],
      thControlColor: COLORS.WHITE,
      thControlColorBg: COLORS.BLUE,
    };
  },
};
